import React from 'react';
import JobCard from './JobCard';

const RolesSection = ({ 
  title,
  description,
  jobs,
  buttonText = 'Entry',
  linkText = 'この職種の魅力',
  sectionClass = 'roles-section',
  containerClass = 'roles-container',
  titleClass = 'roles-title',
  descriptionClass = 'roles-description',
  cardsWrapperClass = 'job-cards-wrapper'
}) => {
  return (
    <section className={sectionClass} aria-labelledby="roles-heading">
      <div className={containerClass}>
        <h2 className={titleClass} id="roles-heading">{title}</h2>
        <p className={descriptionClass}>
          {description}
        </p>
      </div>

      <div className={cardsWrapperClass}>
        {jobs.map((job, index) => (
          <JobCard
            key={index}
            variant="glassmorphism"
            titleEn={job.titleEn}
            titleJa={job.titleJa}
            description={job.desc || job.description}
            buttonText={buttonText}
            buttonLink={job.buttonLink || job.path || '/entry'}
            linkText={linkText}
            linkUrl={job.linkUrl || job.link || job.path}
            seniorsUrl={job.seniorsUrl}
            image={job.image}
          />
        ))}
      </div>
    </section>
  );
};

export default RolesSection;
